import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BookingModel, BookingService, LayoutService, NavigationResolver, NavigationService, ActiveRentalService } from 'app-components';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { InsightsService, PageBase, RentalInfo, RentalStatus, TurboHubEventType } from 't4core';

@Component({
    selector: 'app-booking-info',
    templateUrl: './booking-info.component.html',
    styleUrls: ['./booking-info.component.css'],
    standalone: false
})
export class BookingInfoComponent extends PageBase implements OnInit, OnDestroy {

  public booking: RentalInfo;
  public tooEarly: boolean = false;
  public tooFarAway: boolean = false;

  public countdown: moment.Duration;
  public logoImageBegin: string = "https://thuleturbo.blob.core.windows.net/locationgrouppictures/3_";
  public logoImageEnd: string = ".png?g=";

  public isReturn: boolean = false;
  public firstLoad = true;
  public firstLoadLoader = false;
  public updateInProgress = false;
  public updateInProgressWait = false;
  public locationTries: number = 0;

  public hasLock: boolean = false;
  public allowUnmanned: boolean = false;
  public isNuwiel: boolean = false;

  constructor(el: ElementRef, public appService: AppIntegrationService, private navigation: NavigationService, private rentalService: ActiveRentalService, public layoutService: LayoutService, public appSettings: AppSettingsService, private resolver: NavigationResolver, private insights: InsightsService, private bookingDataService: BookingService) {
    super(el);
  }

  private notificationSub: Subscription;
  async ngOnInit() {

      var token = this.UI.beginLoading("Intellitrailer.Rental.BookingInfo.msgLoadingOptions", "Loading booking data", null);
    await this.init();

    if (this.booking && this.booking.Id) {

      var appStore = this.appSettings.clientVersion + " (" + this.appSettings.appVersion ? this.appSettings.appVersion : "" + ")";
      var info = "Opened booking. Device info: " + appStore + ". " + navigator.userAgent;
      this.Api.post<boolean>("Rental/LogEvent", info, { rentalId: this.booking.Id });

      var info = 'Status: ' + this.booking.Status + '. Lock: ' + this.hasLock;
      this.Api.post<boolean>("Rental/LogEvent", info, { rentalId: this.booking.Id });

      const now = new Date();
      const pickup = this.booking.PickupTime.toDate();
      this.tooEarly = now < new Date(pickup.getTime() - 15 * 60 * 1000);

    }

    this.UI.loaderCompleted(token);

    this.notificationSub = this.Notifications.onEvent.pipe(filter(x => x.Type == TurboHubEventType.Booking && x.EntityId == this.booking.Id.toString())).subscribe(async x => {
      this.booking = await this.rentalService.getBooking();

      this.init();
    });
  }

  async ngOnDestroy() {
    if (this.notificationSub) this.notificationSub.unsubscribe();
  }

  private async init() {
    this.booking = await this.rentalService.getBooking();
    if (this.booking.Status >= RentalStatus.Active) this.navigation.executeCommand("StartedRemotely");

    //Check if object has lock
    this.hasLock = await this.rentalService.hasLock();
    this.allowUnmanned = await this.rentalService.allowUnmanned();
    this.isNuwiel = await this.rentalService.isNuwiel();

    this.isReturn = (this.booking && (this.booking.Status == RentalStatus.Active || this.booking.Status == RentalStatus.Late));
  }

  public recieveRentalAction(action: string) {
    switch (action) {
      case "start": {
        this.start(); break;
      }
      case "cancelBooking": { this.cancelBooking(); break; }
    }
  }

  async secondTick() {
  }

  async minuteTick() {
  }
  public async start() {
   

    //Override for demo (Set user as at location)
    if (localStorage.getItem('atLocation')) {
      this.tooFarAway = localStorage.getItem('atLocation') == "true" ? false : this.tooFarAway;
    } else {
      //Check if user is to far away to start/return trailer
      var distance = await this.appService.getDistanceFromUser(this.booking.PickupLocation.TrailerPointLatitude, this.booking.PickupLocation.TrailerPointLongitude) * 1000;
      this.tooFarAway = distance > this.booking.PickupLocation.TrailerPointRadius + 1000;
    }
 
    var hasTag = await this.rentalService.hasTag()
    this.insights.logEvent("Pickup started", { isLockless: hasTag + "", hasLock: this.hasLock + "", rentalId: this.booking.Id.toString() });

    // Pickup Device Info
    var userAgent = navigator.userAgent;
    const deviceInfo = userAgent.match(/\(([^)]+)\)/);
    this.booking.PickupDevice = deviceInfo[1];

    this.navigation.executeCommand("Start");
  }    
     
  public async cancelBooking() {
    var c = await this.rentalService.cancel();
    if (c) {
      this.navigation.executeCommand("Canceled");
    }
  }

  public async changeRentalTimes() {
    var cleared = await this.bookingDataService.startSession();
    if (cleared) { 
    var bookingState: BookingModel = {
      booking: this.booking,
      freshLoad: true,
      timeSteps: "quarter",
      session: moment().milliseconds(),
      existingBooking: this.booking.Id + "",
      objectCategories: [],
    };
    this.bookingDataService.saveState(bookingState);
      this.navigation.executeCommand("ChangeRentalTimes", { event: "ChangeRentalTime", rentalId: this.booking.Id });
    }
  }

  public openExternal(url: string) {
    this.appService.openExternal(url);
  }

  public back() {
    this.navigation.back();
  }

  public cantFindTrailer() {
    this.navigation.executeCommand("SwapTrailer", {rentalId: this.booking.Id, fromPath:"booking"})
  }

}
